module.exports = __webpack_public_path__ + "img/166-Shogun AF.jpg";